import { prepareApartmentBody } from "../../utils/api_params";
import { prepareParams } from "../../utils/api_params";
export const apartmentApi = (api) =>
  api.injectEndpoints({
    endpoints: (build) => ({
      getApartments: build.query({
        query: () => {
          return `v1/apartments`;
        },
      }),
      getApartmentDevices: build.query({
        query: ({ id, params }) => {
          return `v1/apartments/${id}/devices?${prepareParams(params)}`;
        },
      }),
      addApartment: build.mutation({
        query: (attributes) => ({
          method: "POST",
          url: "v1/apartments",
          body: JSON.stringify(prepareApartmentBody(attributes)),
        }),
      }),
    }),
  });
